import { useDeviceOptionsStore } from "../storez/DeviceOptionsStore";

// TODO: Refactor to use a more appropriate approach for determining layout based on hostname
class LayoutConfig {
  constructor() {
    this.layout = {
      familyzone: {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo_family_zone_horizontal_blue.svg",
        classwize_link: "https://classwize.syd-2.linewize.net",
        title: "Linewize Filter",
        region: "syd-2",
      },
      "us-1": {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo_family_zone_horizontal_blue.svg",
        classwize_link: "https://us.classroom.qoria.cloud",
        title: "Linewize Filter",
        region: "us-1",
        qauthForgotPasswordLink: "https://user-info.auth.qoriaapis.cloud/api/v1.0/password/reset",
      },
      "au-1": {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo_family_zone_horizontal_blue.svg",
        classwize_link: "https://classroom.au-1.familyzone.io",
        title: "Linewize Filter",
        region: "syd-2",
        qauthForgotPasswordLink: "https://user-info.auth.qoriaapis.cloud/api/v1.0/password/reset",
      },
      "uk-1": {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo_family_zone_horizontal_blue.svg",
        classwize_link: "https://classwize.uk-1.linewize.net",
        title: "Linewize Filter",
        region: "uk-1",
        qauthForgotPasswordLink: "https://user-info.auth.qoriaapis.cloud/api/v1.0/password/reset",
      },
      beta: {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo.png",
        login_logo_inverted: "/static/images/logo_inverted.png",
        classwize_link: "https://classwize.qoria-stg.cloud",
        title: "Beta Region",
        region: "beta-1",
        qauthForgotPasswordLink: "https://user-info.auth.qoriaapis-stg.cloud/api/v1.0/password/reset",
      },
      sit: {
        logo: "/static/images/logo.png",
        login_logo: "/static/images/logo.png",
        login_logo_inverted: "/static/images/logo_inverted.png",
        classwize_link: "https://sit.classwize.linewize.net",
        title: "Dev/Test Region",
        region: "sit",
        qauthForgotPasswordLink: "https://user-info.auth.qoriaapis-sit.cloud/api/v1.0/password/reset",
      },
    };

    this.layout["cloud.sit.linewize.net"] = this.layout["sit"];
    this.layout["linewizefilter.qoria-sit.cloud"] = this.layout["sit"];
    this.layout["schoolmanager.qoria-sit.cloud"] = this.layout["sit"];

    this.layout["localhost"] = { ...this.layout["beta"], classwize_link: "http://localhost:8081" };
    this.layout["cloud.beta-1.linewize.net"] = this.layout["beta"];
    this.layout["linewizefilter.qoria-stg.cloud"] = this.layout["beta"];
    this.layout["schoolmanager.qoria-stg.cloud"] = this.layout["beta"];

    this.layout["schoolmanager.uk-1.linewize.net"] = this.layout["uk-1"];
    this.layout["uk.linewizefilter.qoria.cloud"] = this.layout["uk-1"];

    this.layout["cloud.syd-2.linewize.net"] = this.layout["au-1"];
    this.layout["schoolmanager.au-1.familyzone.io"] = this.layout["au-1"];
    this.layout["au.linewizefilter.qoria.cloud"] = this.layout["au-1"];

    this.layout["cloud.syd-1.linewize.net"] = this.layout["us-1"];
    this.layout["schoolmanager.us-1.familyzone.io"] = this.layout["us-1"];
    this.layout["us.linewizefilter.qoria.cloud"] = this.layout["us-1"];
  }

  getResource(name) {
    if (this.layout[window.location.hostname]) {
      return this.layout[window.location.hostname][name];
    }
    return this.layout["us-1"][name];
  }

  logo() {
    return this.getResource("logo");
  }

  region() {
    return this.getResource("region");
  }

  login_logo(inverted) {
    if (inverted && this.getResource("login_logo_inverted")) {
      return this.getResource("login_logo_inverted");
    }
    return this.getResource("login_logo");
  }

  classwize_link() {
    return this.getResource("classwize_link");
  }

  title() {
    // Dev regions
    if (this.getResource("title") !== "Linewize Filter") {
      return this.getResource("title");
    }

    // Show Smoothwall title only if device options are available and company is "smoothwall"
    const deviceOptions = useDeviceOptionsStore.getState().options;

    const isSmoothwallBranding = deviceOptions?.customer_internal_company?.toLowerCase() === "smoothwall";

    if (isSmoothwallBranding) {
      return "Smoothwall Filter";
    }

    return "Linewize Filter";
  }

  qauthForgotPasswordLink() {
    return this.getResource("qauthForgotPasswordLink");
  }
}

const Layout = new LayoutConfig();
export default Layout;
